import {Button, Col, Row} from 'antd';
import ModalForm from 'components/ModalForm';
import {AuthContext} from 'context/Auth.context';
import moment from 'moment';
import {useContext, useState} from 'react';
import fields from './commands.form';
import '../Applications/Applications.less';
import {StudentContext} from 'context/Student.context';

interface IAppDataTypes {
	categoryID: number;
	content: string;
	contentFr: string;
	date: string;
	effectiveDate: string;
	id: number;
	number: string;
	path: string;
	title: string;
	titleFr: string;
	typeID: number;
	typeName: string;
}

const ApplicationCard = ({
	handleViewApplication,
	data
}: {
	data: IAppDataTypes;
	handleViewApplication: () => void;
}) => {
	return (
		<div className="ApplicationCard">
			<div className="title">
				<span>Հրաման {data.number}</span>
			</div>
			<div className="description">
				<div className="info">
					<div id="about">Վերնագիր՝</div>
					<div id="about-info">{data.title}</div>
				</div>
				<div className="info">
					<div id="about">Վերնագիր Ֆրանսերեն՝</div>
					<div id="about-info">{data.titleFr}</div>
				</div>
				<div className="info">
					<div id="about">Հրամանի ամսաթիվ՝</div>
					<div id="about-info">{moment(data.date).utc().format('DD-MM-YYYY')}</div>
				</div>
				<div className="info">
					<div id="about">Ուժի մեջ է սկսած՝</div>
					<div id="about-info">{moment(data.effectiveDate).utc().format('DD-MM-YYYY')}</div>
				</div>
			</div>
			<div className="actions">
				<Button onClick={handleViewApplication} type="primary">
					Դիտել
				</Button>
			</div>
		</div>
	);
};

const Commands = () => {
	const [modalVisible, setModalVisible] = useState<'VIEW' | false>(false);
	const [choosedCommand, setChoosedCommand] = useState({});

	const {
		state: {student}
	} = useContext(AuthContext);

	const {
		state: {commands}
	} = useContext(StudentContext);

	const role = student ? 'STUDENT' : 'CANDIDATE';

	return (
		<>
			<div className="container applications">
				<Row gutter={{xs: 8, sm: 16, md: 24, lg: 32}}>
					{commands.length ? (
						commands.map((data, i) => (
							<Col key={i} sm={12} xs={24} md={12} lg={12} xl={6}>
								<ApplicationCard
									handleViewApplication={() => {
										setChoosedCommand(data);
										setModalVisible('VIEW');
									}}
									data={data}
								/>
							</Col>
						))
					) : (
						<Col sm={24} lg={24}>
							<div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
								<span>Հրամմաններ չեն հայտնաբերվել</span>
							</div>
						</Col>
					)}
				</Row>
			</div>
			<ModalForm
				getFieldsValues={() => new Promise<any>(res => res({data: choosedCommand}))}
				fields={fields}
				title={'Հրաման'}
				visible={modalVisible}
				selectedRowIds={[0]}
				onCancel={() => setModalVisible(false)}
				editModalType={'TAB'}
				addModalType={'TAB'}
				formErrors={{}}
				loading={false}
			/>
		</>
	);
};

export default Commands;
